import { render, staticRenderFns } from "./WizardDocumentosPersonalizados.vue?vue&type=template&id=6e221a10&scoped=true&"
import script from "./WizardDocumentosPersonalizados.vue?vue&type=script&lang=js&"
export * from "./WizardDocumentosPersonalizados.vue?vue&type=script&lang=js&"
import style0 from "./WizardDocumentosPersonalizados.vue?vue&type=style&index=0&id=6e221a10&lang=scss&scoped=true&"
import style1 from "./WizardDocumentosPersonalizados.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e221a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e221a10')) {
      api.createRecord('6e221a10', component.options)
    } else {
      api.reload('6e221a10', component.options)
    }
    module.hot.accept("./WizardDocumentosPersonalizados.vue?vue&type=template&id=6e221a10&scoped=true&", function () {
      api.rerender('6e221a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/WizardDocumentosPersonalizados.vue"
export default component.exports